import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, switchMap } from 'rxjs/operators';
import * as fromShared from '../../../shared';
import { CustomerAdminService } from '../../customer-admin.service';
import * as AdvisorActions from './advisor.actions';

@Injectable()
export class AdvisorEffects {
    constructor(
        private actions$: Actions,
        private service: CustomerAdminService
    ) {}

    get$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AdvisorActions.getAdvisor),
            switchMap(a =>
                this.service.getAdvisors().pipe(
                    flatMap(resp => [
                        AdvisorActions.loadAdvisors({
                            Advisors: JSON.parse(resp)
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
}
